import React from "react";
import "../assets/css/errorModal.css";
import ErrorIcon from "../assets/images/error_icon.svg";

const ErrorModal = ({ error, closeErrorModal }) => {
  return (
    <div className={`success-modal ${error ? "open" : ""}`}>
      <div className="success-modal-content">
        <img src={ErrorIcon} alt="Success Icon" />
        <h2 className="success-modal-heading">Report Submission Failed!</h2>
        <p className="success-modal-message">{error && error}</p>
        <button onClick={closeErrorModal} className="btn success-modal-button">
          OK
        </button>
      </div>
    </div>
  );
};

export default ErrorModal;
